<template>
  <div class="hamburger">
    <div class="bar bar1"></div>
    <div class="bar bar2"></div>
    <div class="bar bar3"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/color.scss';
@import '~@/stylesheets/function.scss';

$color-burger: $color_bleu_de_france;
$color-active: white;
$bar-height: .3rem;

.hamburger {
  cursor: pointer;

  height: rem(25);
  line-height: rem(1);
  margin: rem(6) 0;
  overflow: hidden;
  position: relative;
  width: rem(35);
  top: 50%;
  transform: translate(-50%, -50%);

  &.active {
    height: rem(25) !important;
    .bar {
      background-color: $color-active;
      border-radius: 0%;
      height: rem(3);
      &1 {
        top: 50%;
        width: 75%;
        left: 12.5%;
        transform: rotate(-45deg);
      }
      &2 {
        opacity: 0;
      }
      &3 {
        top: 50%;
        width: 75%;
        right: 12.5%;
        transform: rotate(45deg);
      }
    }
  }
}
.bar {
  background-color: $color-burger;
  border-radius: $bar-height/2;
  width: $bar-height;
  height: $bar-height;
  position: absolute;
  transition: all .3s cubic-bezier(0.075, 0.82, 0.165, 1);

  &1 {
    top: 50%;
    // width: $bar-width;
    left: rem(4);
    transform: translate(0, -50%);
  }

  &2 {
    float: right;
    top: 50%;
    // width: $bar-width;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &3 {
    top: 50%;
    // width: $bar-width;
    right: .3rem;
    transform: translate(0, -50%);
  }
}
</style>
